import { FC } from 'react';
import { useActionFormContext } from './ActionForm.context';
import { Dots } from '@silo/ui';

interface SubmitButtonContentProps {
  submitCopy: string;
  submittingCopy: string;
}

export const SubmitButtonContent: FC<SubmitButtonContentProps> = ({ submitCopy, submittingCopy }) => {
  const { isPending } = useActionFormContext();

  if (isPending) {
    return <Dots>{submittingCopy}</Dots>;
  }

  return <>{submitCopy}</>;
};
